<template>
  <div class="register-page">
    <div class="register-bg"
         aria-hidden="true"></div>
    <div class="register-shell">
      <div class="register-card">
        <div class="register-header">
          <div class="register-title">账号注册</div>
          <div class="title-line"></div>
        </div>

        <div class="register-form">
          <div class="input-item">
            <img src="../../static/image/zhanghao.png"
                 alt=""
                 class="input-icon" />
            <el-input placeholder="请输入姓名"
                      v-model="ruleForm.name"
                      class="register-input" />
          </div>
          <div class="input-item">
            <img src="../../static/image/mima2.png"
                 alt=""
                 class="input-icon" />
            <el-input placeholder="请输入手机号"
                      v-model="ruleForm.tel"
                      maxlength="11"
                      class="register-input" />
          </div>
          <div class="input-item code-item">
            <img src="../../static/image/code.png"
                 alt=""
                 class="input-icon" />
            <el-input placeholder="请输入验证码"
                      v-model="ruleForm.code"
                      class="register-input" />
            <el-button type="primary"
                       class="code-btn"
                       @click="getCaptcha">{{ buttonText }}</el-button>
          </div>
          <div class="input-item">
            <img src="../../static/image/mima.png"
                 alt=""
                 class="input-icon" />
            <el-input placeholder="请输入密码"
                      v-model="ruleForm.pwd"
                      type="password"
                      class="register-input"
                      show-password />
          </div>
          <div class="input-item">
            <img src="../../static/image/gongsi.png"
                 alt=""
                 class="input-icon" />
            <el-input placeholder="请输入公司名称"
                      v-model="ruleForm.company"
                      class="register-input" />
          </div>
          <div class="input-item">
            <img src="../../static/image/tuijianren.png"
                 alt=""
                 class="input-icon" />
            <el-input placeholder="请输入推荐人手机号"
                      v-model="ruleForm.invite_tel"
                      maxlength="11"
                      class="register-input" />
          </div>

          <div class="checkbox-item"
               @click="changeRadio">
            <div class="checkbox"
                 :class="{ checked: radio }">
              <i class="el-icon-check"
                 v-if="radio"></i>
            </div>
            <span>阅读并同意</span>
            <span class="link"
                  @click.stop="getInfo('user_agreement')">《用户协议》</span>
            <span class="link"
                  @click.stop="getInfo('privacy')">《隐私政策》</span>
          </div>

          <el-button type="primary"
                     class="register-btn"
                     @click="submitForm('ruleForm')">立即注册</el-button>
        </div>
        <div class="login-link">
          <span @click="goLogin">已有账号？立即登录</span>
        </div>
        <div class="register-footer-inner">
          <div class="company-name">千顷职汇人力资源有限公司</div>
        </div>
      </div>
    </div>

    <footer class="register-viewport-footer"
            @click="goXinfan">
      <img class="support-brand-img"
           src="../../static/image/login/xinfan.png"
           alt="新帆软件技术支持"
           title="新帆软件技术支持" />
    </footer>
    <el-dialog title="城市"
               :visible.sync="dialogVisible"
               width="800px"
               :before-close="handleClose">
      <cityPage @changeCity="changeCity" />
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import cityPage from '@/components/cityPage.vue'
export default {
  name: '',
  components: {
    cityPage,
  },
  data() {
    return {
      radio1: '企业注册',
      ruleForm: {
        // name: '',
        // region: '',
        // date1: '',
        // date2: '',
        // type: [],
        // resource: '',
        // desc: '',
        // // city: ""

        tel: '',
        code: '',
        // user_type: "1",
        key: '',
        name: '',
        email: '',
        company: '',
        city_id: '',
        company_year: '',
        company_fee: '',
        company_month_fee: '',
        invite_tel: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' },
        ],
        tel: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { min: 11, max: 11, message: '长度在11字符', trigger: 'blur' },
        ],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change'],
          },
        ],
        company: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
        ],
        city_id: [{ required: true, message: '请选择城市', trigger: 'change' }],
        pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        company_fee: [
          { required: true, message: '请输入投资预算', trigger: 'blur' },
        ],
        company_month_fee: [
          { required: true, message: '请输入月收入预期', trigger: 'blur' },
        ],
        // date1: [
        //     { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
        // ],
        // date2: [
        //     { type: 'date', required: true, message: '请选择时间', trigger: 'change' }
        // ],
        // type: [
        //     { type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change' }
        // ],
        // resource: [
        //     { required: true, message: '请选择活动资源', trigger: 'change' }
        // ],
        // desc: [
        //     { required: true, message: '请填写活动形式', trigger: 'blur' }
        // ]
      },
      typeList: [
        {
          label: '企业注册',
          id: '1',
        },
        {
          label: '个人注册',
          id: '2',
        },
      ],
      radio: false,
      isDisabled: false, // 控制按钮是否禁用
      countdown: 0, // 倒计时时间
      intervalId: null, // 定时器的ID
      dialogVisible: false,
      select: '',
    }
  },
  beforeMount() {
    console.log(this.$route.path, 'this.$route.path')
  },
  mounted() {},
  beforeDestroy() {},
  computed: {
    user_type() {
      return this.radio1 == '企业注册' ? '1' : '2'
    },
    buttonText() {
      return this.isDisabled ? `${this.countdown}秒后重新获取` : '获取验证码'
    },
  },
  methods: {
    changeRadio() {
      this.radio = !this.radio
      console.log(this.radio, 'changeRadio')
    },
    goLogin() {
      this.$router.push('/login')
    },
    goXinfan() {
      window.open('https://www.seenfine.com/', '_blank')
    },
    getInfo(type) {
      // this.$router.push({
      //     path: '/article', query: {
      //         type: type
      //     },target:'_blank'
      // });
      // this.$router.go(0)
      const targetRoute = this.$router.resolve({
        name: 'article',
        query: { type: type },
      })
      window.open(targetRoute.href, '_blank')
    },
    submitForm() {
      if (!this.radio) {
        this.$message.warn('请先同意《用户协议》《隐私政策》')
        return
      }
      if (!this.ruleForm.name) {
        this.$message.error('请输入姓名')
        return
      }
      if (!this.ruleForm.tel) {
        this.$message.error('请输入手机号')
        return
      }
      if (!this.ruleForm.code) {
        this.$message.error('请输入验证码')
        return
      }
      if (!this.ruleForm.pwd) {
        this.$message.error('请输入密码')
        return
      }
      this.ruleForm.user_type = this.user_type
      console.log(this.ruleForm, 'ruleForm')
      this.$api.index.register(this.ruleForm).then((res) => {
        console.log(res)
        if (res.code == 200) {
          this.$message.success(res.msg)
          this.$router.push('/login')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    changeType() {
      console.log('changeType', this.radio1)
      this.resetForm('ruleForm')
    },
    async getCaptcha() {
      if (this.isDisabled) return // 如果按钮被禁用，则不执行任何操作
      if (!this.ruleForm.tel) {
        this.$message.error('请先输入手机号')
        return
      }
      // 发送获取验证码的请求（这里应该是你的API调用）
      await this.$api.index.getVerify({ type: '2' }).then((res) => {
        console.log(res)
        if (res.code == 200) {
          this.ruleForm.key = res.data.key
          this.$api.index
            .sendSms({ key: this.ruleForm.key, tel: this.ruleForm.tel })
            .then((res) => {
              console.log(res)
              if (res.code == 200) {
                this.$message.success('验证码已发送')
              } else {
                this.$message.error(res.msg)
              }
            })
        } else {
          this.$message.error('请求失败请稍后重试')
        }
      })
      console.log('发送验证码请求')

      // 开始倒计时
      this.startCountdown()
    },
    startCountdown() {
      this.isDisabled = true // 禁用按钮
      this.countdown = 60 // 设置倒计时为60秒
      this.intervalId = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown -= 1 // 每秒减少1
        } else {
          clearInterval(this.intervalId) // 倒计时结束，清除定时器
          this.isDisabled = false // 重新启用按钮
          this.countdown = 0 // 重置倒计时时间
        }
      }, 1000) // 每秒执行一次
    },

    submit() {
      this.select = localStorage.getItem('cityName')
      this.ruleForm.city_id = localStorage.getItem('cityId')
      this.dialogVisible = false
    },
    changeCity(item) {
      localStorage.setItem('cityId', item.id)
      localStorage.setItem('cityName', item.title)
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },
  },
}
</script>

<style scoped lang="scss">
.register-page {
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  background: linear-gradient(
    180deg,
    #d6ecff 0%,
    #eef6ff 38%,
    #f8fbff 72%,
    #ffffff 100%
  );
}

.register-bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image: radial-gradient(
      ellipse 120% 80% at 50% -15%,
      rgba(59, 130, 246, 0.12) 0%,
      transparent 52%
    ),
    radial-gradient(
      ellipse 70% 45% at 100% 100%,
      rgba(14, 165, 233, 0.08) 0%,
      transparent 48%
    ),
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.82) 0%,
      rgba(255, 255, 255, 0.35) 42%,
      rgba(255, 255, 255, 0) 100%
    ),
    url('~@/static/image/login/background.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.register-shell {
  position: relative;
  z-index: 1;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: clamp(24px, 6vw, 80px);
  padding: 48px 24px 120px;
  flex-wrap: wrap;
}

.register-card {
  width: 100%;
  max-width: 440px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e8eef5;
  box-shadow: 0 12px 40px rgba(15, 23, 42, 0.08),
    0 2px 8px rgba(15, 23, 42, 0.04);
  padding: 0 0 28px;
  box-sizing: border-box;
}

.register-header {
  text-align: center;
  padding: 40px 32px 8px;
}

.register-title {
  font-size: 26px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: 0.02em;
}

.title-line {
  width: 48px;
  height: 3px;
  border-radius: 2px;
  background: linear-gradient(90deg, #3b82f6, #0ea5e9);
  margin: 18px auto 0;
}

.register-form {
  padding: 8px 36px 0;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 280px);
  overflow-y: auto;
}

.input-item {
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e8eef5;
  border-radius: 10px;
  width: 100%;
  max-width: 368px;
  margin: 0 auto 16px;
  padding: 4px 14px;
  box-sizing: border-box;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.input-item:focus-within {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
  background: #fff;
}

.input-icon {
  width: 22px;
  height: 22px;
  margin-right: 10px;
  flex-shrink: 0;
}

::v-deep .register-input .el-input__inner {
  border: none;
  outline: none;
  box-shadow: none;
  background: transparent;
  height: 46px;
  line-height: 46px;
  font-size: 15px;
  color: #0f172a;
}

::v-deep .register-input .el-input__inner::placeholder {
  color: #94a3b8;
}

.code-item {
  position: relative;
}

.code-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 100px;
  height: 32px;
  border-radius: 6px;
  font-size: 13px;
  padding: 0;
}

.checkbox-item {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 13px;
  color: #64748b;
  margin: 8px auto 20px;
  max-width: 368px;
  width: 100%;
  cursor: pointer;
  user-select: none;
  gap: 2px 0;
}

.checkbox {
  width: 18px;
  height: 18px;
  border: 2px solid #cbd5e1;
  border-radius: 4px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #fff;
  background: #fff;
  flex-shrink: 0;
  transition: all 0.2s;
}

.checkbox.checked {
  background: linear-gradient(145deg, #3b82f6, #0ea5e9);
  border-color: transparent;
}

.checkbox-item .link {
  color: #2563eb;
  margin: 0 4px;
  font-weight: 500;
}

.checkbox-item .link:hover {
  text-decoration: underline;
}

.register-btn {
  width: 100%;
  max-width: 368px;
  height: 48px;
  margin: 0 auto;
  border: none;
  border-radius: 999px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.35em;
  padding-left: 0.35em;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.28);
}

::v-deep .register-btn:hover,
::v-deep .register-btn:focus {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
}

.login-link {
  color: #2563eb;
  text-align: center;
  padding: 12px 0;
  font-weight: 500;
  cursor: pointer;
}

.register-footer-inner {
  text-align: center;
  padding: 20px 32px 0;
  margin-top: 8px;
}

.company-name {
  font-size: 13px;
  color: #94a3b8;
  line-height: 1.6;
}

.register-viewport-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  gap: 8px;
  padding: 12px 16px 16px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.92) 40%,
    #ffffff 100%
  );
  border-top: 1px solid rgba(226, 232, 240, 0.9);
}

.support-brand-img {
  height: 16px;
  object-fit: contain;
}

@media (min-width: 901px) {
  .register-shell {
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    box-sizing: border-box;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: nowrap;
    gap: clamp(20px, 3vw, 48px);
    padding: 48px clamp(24px, 4vw, 56px) 120px;
  }

  .register-card {
    flex: 0 0 auto;
    margin-left: 0;
    width: 100%;
    max-width: 440px;
  }
}
</style>